export enum Environment {
    DEV = 1,
    Test = 2,
    UAT = 3,
    PROD = 4,
    DEMO = 5
}